import { SCREENS } from "utils/constants";
import List from "./List";

const routes = [
  {
    path: SCREENS.PRIVATE.ORGANIZATION.LIMITS.LIST,
    exact: true,
    element: <List />,
  },
];

export default routes;
